import { render } from "./index.vue?vue&type=template&id=f2e0a6ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f2e0a6ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e0a6ea"],['__file',"src/views/SignUpMFA/components/step4/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2e0a6ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2e0a6ea', __exports__)) {
    api.reload('f2e0a6ea', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f2e0a6ea&scoped=true", () => {
    api.rerender('f2e0a6ea', render)
  })

}


export default __exports__